import { filterName } from "../utils";
import { createEmptyFilters } from "./utils";

export const getSharedSmartFilters = (appliedFilters, setAppliedFilters) => {
  return [
    {
      text: "My favorites",
      applied: appliedFilters[filterName.MY_FAVORITES],

      onClick: () => {
        const updatedFilters = createEmptyFilters(appliedFilters);
        updatedFilters[filterName.MY_FAVORITES] = true;
        setAppliedFilters(updatedFilters);
      },
    },
  ];
};
